import { useEffect } from 'react';
import { sqWorkbookStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { useRoutingData } from '@/main/useRoutingData.hook';
import { FAVICON } from '@/main/app.constants';
import { useLocation, useParams } from 'react-router-dom';
import { getDocumentTitle } from '@/utilities/utilities';
import { getFavIconElement } from '@/utilities/dom.utilities';

/**
 * This component manages the tab title display as well as the favicon
 */
export const TabTitle: React.FunctionComponent = () => {
  const { isWorksheetDisplayed, isViewMode } = useRoutingData();
  const location = useLocation();
  const isReport = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.isTopic);
  const isVantage = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.isVantage);
  const isActionBoard = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.isActionBoard);
  const workbookName = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.name);
  const worksheets = useFluxPath(sqWorkbookStore, () => sqWorkbookStore.worksheets);

  const { worksheetId } = useParams();
  useEffect(() => {
    let favicon = FAVICON.WORKBENCH;
    if (isWorksheetDisplayed || isViewMode) {
      if (isReport) {
        favicon = FAVICON.BLUE;
      } else if (isVantage) {
        favicon = FAVICON.PURPLE;
      } else if (isActionBoard) {
        favicon = FAVICON.ACTION_BOARD;
      } else {
        favicon = FAVICON.GREEN;
      }
    }
    getFavIconElement().href = favicon;
    document.title = getDocumentTitle(location.pathname, worksheetId);
  }, [
    isWorksheetDisplayed,
    isViewMode,
    isReport,
    isVantage,
    isActionBoard,
    location.pathname,
    workbookName,
    worksheets,
  ]);

  return null;
};
